export const MODERATOR_CONSTS = {
    GET_MODERATORS: "GET_MODERATORS",
    ADD_MODERATOR: "ADD_MODERATOR",
    EDIT_MODERATOR: "EDIT_MODERATOR",
    DELETE_MODERATOR: "DELETE_MODERATOR",

};
